import { createToaster } from "@meforma/vue-toaster";

function escapeMessage(message) {
    return String(message ?? "").replace(/[&<>"']/g, (character) => ({
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
    })[character]);
}

// The library renders messages with v-html. Every application toast is text,
// including record names and API errors, so escape at the shared entry point.
export function createPlainTextToaster(options = {}) {
    const toaster = createToaster(options);
    const show = (message, options = {}) => {
        const { message: override = message, ...props } = options;
        return toaster.show(escapeMessage(override), props);
    };
    return {
        show,
        clear: () => toaster.clear(),
        success: (message, options = {}) => show(message, { ...options, type: "success" }),
        error: (message, options = {}) => show(message, { ...options, type: "error" }),
        info: (message, options = {}) => show(message, { ...options, type: "info" }),
        warning: (message, options = {}) => show(message, { ...options, type: "warning" })
    };
}

export const ToastPlugin = {
    install(app, toaster) {
        app.$toast = toaster;
        app.config.globalProperties.$toast = toaster;
    }
};
